var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 18,
    viewBox: "0 0 10 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.52128 0.00110565V3.59224H7.70408C7.41508 3.6068 7.15648 3.77642 7.02798 4.03572C6.88228 4.31618 6.80798 4.62827 6.81168 4.94432V7.1834H9.51588V10.8178H6.81168V18H3.18268V10.8178H0.478516V7.1834H3.18268V3.59224C3.18568 2.63993 3.56698 1.72785 4.24268 1.05681C4.92768 0.376566 5.85498 -0.00359438 6.82028 2.5618e-05L9.52128 0.00110565Z",
    fill: "#101828"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFace);
export default __webpack_public_path__ + "static/media/face.c9d1f44ec251fec893bf0b5590dfebfa.svg";
export { ForwardRef as ReactComponent };